import { store, getContext } from "@wordpress/interactivity";

function normalize(str) {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();
}

store("cappelli/instant-search", {
  actions: {
    onSearch(e) {
      const ctx = getContext();
      const query = e.target.value;

      ctx.query = query;
      ctx.hasSearched = query.trim().length > 0;

      if (!ctx.hasSearched) {
        ctx.results = [];
        updateDOM(ctx);
        return;
      }

      const needle = normalize(query);

      ctx.results = ctx.posts.filter(
        (post) =>
          normalize(post.titolo).includes(needle) ||
          normalize(post.excerpt).includes(needle),
      );

      updateDOM(ctx);
    },
  },
});

function updateDOM(ctx) {
  const wrappers = document.querySelectorAll(
    '[data-wp-interactive="cappelli/instant-search"]',
  );

  wrappers.forEach((wrapper) => {
    const resultsWrap = wrapper.querySelector(
      ".instant-search__results-wrapper",
    );
    const emptyMsg = wrapper.querySelector(".instant-search__empty");
    const groups = wrapper.querySelectorAll(".instant-search__group");

    if (resultsWrap) resultsWrap.hidden = !ctx.hasSearched;

    if (!ctx.hasSearched) {
      groups.forEach((g) => (g.hidden = true));
      if (emptyMsg) emptyMsg.hidden = true;
      return;
    }

    const resultIds = new Set(ctx.results.map((p) => p.id));
    let totalVisible = 0;

    groups.forEach((group) => {
      const items = group.querySelectorAll(".instant-search__item");
      let groupVisible = 0;

      items.forEach((item) => {
        const id = parseInt(item.dataset.postId, 10);
        const visible = resultIds.has(id);
        item.style.display = visible ? "" : "none";
        if (visible) groupVisible++;
      });

      group.hidden = groupVisible === 0;
      totalVisible += groupVisible;
    });

    if (emptyMsg) emptyMsg.hidden = totalVisible > 0;
  });
}
